import { RESET } from '../redux/game'
import { LOGOUT } from '../redux/auth'
import { registerWeb } from '../redux/device'
import adminApi from '../services/admin-api'
import navigation from '../services/navigation'

// Actions
const FETCH_EVENT_START = 'ascension/event/fetching'
const FETCH_EVENT_SUCCESS = 'ascension/event/success'
const FETCH_EVENT_ERROR = 'ascension/event/error'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  details: null
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_EVENT_START: {
      return {
        ...state,
        isLoading: true,
        error: null
      }
    }
    case FETCH_EVENT_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        error: null,
        details: action.data
      }
    }
    case FETCH_EVENT_ERROR: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        error: action.data
      }
    }
    case LOGOUT:
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

// Action Creators

export function fetchEventStart () {
  return {
    type: FETCH_EVENT_START
  }
}

export function fetchEventSuccess (data) {
  return {
    type: FETCH_EVENT_SUCCESS,
    data
  }
}

export function fetchEventError (error) {
  return {
    type: FETCH_EVENT_ERROR,
    data: error
  }
}

export function fetchEventDetails ({ environment, eventId, participantId }) {
  return async (dispatch, store) => {
    dispatch(fetchEventStart())

    try {
      const response = await adminApi.getParticipantDetails({ environment, eventId, participantId })
      dispatch(fetchEventSuccess(response))
      dispatch(registerWeb(response))
    } catch (e) {
      if (e.code !== 401 && e.code !== 403) {
        navigation.doError({ message: e.message })
      }
      dispatch(fetchEventError(e))
    }
  }
}
